module.exports = __webpack_public_path__ + "img/file-exclamation.2df50bc3.svg";